export const currencyFormat = value =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);

export const getOnlyNumbers = (number = '') => {
  return `${number}`.replace(/\D/g, '');
};
